import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import { DefaultApiPostKycconsultingWebhooksRequest } from '@src/api/generated/user-api'

export const postKycconsultingWebhooks = async (
  instance: AxiosInstance,
  params: DefaultApiPostKycconsultingWebhooksRequest
) => {
  return await userApiDefaultApiFactory(instance).postKycconsultingWebhooks(
    params
  )
}
// Do Not Remove this line ===@import api client===
